import http from '@/api/http';
import { removeEmptyStringFields } from '@/util/utils'
// 结构树
export const getMenus = (params) => {
  return http.post(`/ks/menu/v1/menus/main-menus`, params);
};

// 密码登录
export const pwdLogin = (params) => {
  return http.post(`/account/login`, params);
};
// 手机号登录
export const phoneLogin = (params) => {
  // return http.post(`/phone/login`, params, 'formData');
  return http.post(`/phone/login`, params);
};

export const zwssoLogin = (params) => {
  return http.post(`/zwsso/login`, params);
};

// 退出
export const logout = (params) => {
  return http.post(`/logout`, params);
};

// 手机号登录获取验证码
export const phoneLgnSendCode = (params) => {
  return http.post(`/ks/login/v1/send-captcha`, params);
};

// 获取图片验证码
export const imgCaptcha = (params) => {
  return http.get(`ks/login/v1/image/captcha`, params);
};

// 忘记密码发送验证码
export const forgetPwdCaptcha = (params) => {
  return http.post(`/ks/account/v1/forget-pwd/captcha`, params);
};

// 忘记密码校验手机号
export const forgetPwdVerify = (params) => {
  return http.post(`/ks/account/v1/forget-pwd/verify`, params);
};

// 重置密码
export const forgetPwd = (params) => {
  return http.post(`/ks/account/v1/forget-pass`, params);
};

// 企业实名验证
export const realNameVerify = (params) => {
  return http.post(`/ks/register/v1/enterprise-verify`, params);
};

// 企业授权注册
export const authRegister = (params) => {
  return http.post(`/ks/register/v1/enterprise-register`, params);
};

// 企业授权注册
export const sendCode = (params) => {
  return http.post(`/ks/register/v1/send-captcha`, params);
};

// 跳转登录
export const authorizationLogin = (params) => {
  return http.get(`/ks/auth/v1/authorization/login`, params);
};
export const checkLogin = (params) => {
  return http.get(`/ks/auth/v1/authorization/check-login`, params);
};

// export const authorizationLogin = params =>
//   request({
//     url: `/ks/auth/v1/authorization/login`,
//     method: 'get',
//     params
//   }).then(({ data }) => data)

// 修改密码
export const changePwd = (params) => {
  return http.post(`/ks/account/v1/change-pwd`, params);
};
// 申请账户重置
export const resetApply = (params) => {
  return http.post(`/ks/account/v1/reset-apply`, removeEmptyStringFields(params));
};
// 重置账号
export const resetAccount = (params) => {
  return http.post(`/ks/account/v1/reset-account`, params);
};
// 重置账号申请列表  需要分页
export const resetApplyList = (params) => {
  return http.post(`/ks/account/v1/reset-apply/list`, params);
};

